// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZP-z","twoColumnImage":"_P-z"};